import { Component, Input, OnInit } from '@angular/core';
import { ThumbnailsService } from 'src/app/development/thumbnails.service';
import { LocationModel } from '../../../../locations/location.model';
import { GrantedAccessActions } from '@states/granted-access/granted-access.action-types';
import { Store } from '@ngrx/store';
import { LiveStreamModels } from '@models/live-stream.model';

const SHARED_LIVEVIEW_DEFAULT_RESOLUTION = LiveStreamModels.StreamResolution.MQ;

@Component({
  selector: 'app-shared-liveview',
  templateUrl: './shared-liveview.component.html',
  styleUrl: './shared-liveview.component.scss',
  standalone: false,
})
export class SharedLiveviewComponent implements OnInit {
  public readonly defaultResolution: LiveStreamModels.StreamResolution = SHARED_LIVEVIEW_DEFAULT_RESOLUTION;

  @Input() public cameraId;
  @Input() public edgeId;
  @Input() public locationId;
  @Input() public accessToken: string;
  @Input() public isRespectRatio: boolean = true;
  @Input() public cameraName: string;
  @Input() public location: LocationModel.LocationItem;

  public constructor(
    private readonly thumbnailsService: ThumbnailsService,
    private readonly store$: Store,
  ) {}

  public get now(): number {
    return Date.now();
  }

  public async ngOnInit(): Promise<void> {
    await this.thumbnailsService.getGcpTransitionForEdge(this.edgeId);
    this.store$.dispatch(
      GrantedAccessActions.getCameraAudio({ edgeId: this.edgeId, cameraId: this.cameraId }),
    );
  }
}
